<template>
  <div class="color-picker">
    <div class="text-subtitle-2 mb-2">Vald färg</div>
    <div class="d-flex">
      <v-avatar
        height="32"
        width="100"
        tile
        class="rounded"
        :color="selectedColor"
      >
        <div class="white--text text-subtitle-2 my-auto text-center">
          {{ selectedColorName }}
        </div>
      </v-avatar>
    </div>
    <v-divider class="my-4"></v-divider>
    <template v-if="showHexColors">
      <v-color-picker
        v-model="colorPickerColor"
        class="ma-2"
        hide-inputs
        mode="hexa"
        width="490px"
        hide-mode-switch
      ></v-color-picker>
    </template>
    <div v-if="showVuetifyColors" class="d-flex flex-wrap">
      <div
        v-for="color in vuetifyColors"
        :key="color.name"
        class="pa-1"
      >
        <v-btn
          :color="color.name"
          :class="{'elevation-12': selectedColor === color.name || selectedColor === color.hex, 'elevation-2': selectedColor !== color.name && selectedColor !== color.hex}"
          class="ma-0 pa-0"
          height="48"
          @click="selectedColor = color.name"
        >
          <div class="d-flex flex-column p-relative" style="width: 90px; height: 48px;">
            <div class="p-absolute t-0 r-0" style="margin-right: 2px;">
              <v-icon
                v-if="selectedColor === color.name"
                color="white"
                small
              >
                mdi-check-circle-outline
              </v-icon>
              <v-icon v-else color="white" small>
                mdi-circle-outline
              </v-icon>
            </div>
            <div class="white--text my-auto" style="font-size: 10px;">
              {{ color.name_sv }}
            </div>
          </div>
        </v-btn>
      </div>
    </div>
    <div v-if="showHexColors" class="mt-4">
      <v-text-field
        v-model="hexTextField"
        label="HEX-färg (t.ex. #FF5733)"
        outlined
        hide-details
        maxlength="7"
        counter="7"
      ></v-text-field>
    </div>
  </div>
</template>

<style lang="scss">
  .color-picker {
    .v-color-picker__alpha, .v-color-picker__dot {
      display: none;
    }
    .v-color-picker__hue {
      margin-bottom: 0 !important;
    }
  }
</style>

<script>
import { mapState } from 'vuex'

// REVIEW: v-color-picker har inte stöd för färg utan alfakanal i Vuetify 2, men finns i Vuetify 3.
export default {
  name: 'ColorPicker',
  props: {
    value: String,
    showVuetifyColors: {
      type: Boolean,
      default: true
    },
    showHexColors: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    hexTextField: ''
  }),
  computed: {
    ...mapState(
      {
        vuetifyColors: state => state.vuetifyColors
      }
    ),
    selectedColor: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    },
    selectedColorName: function () {
      const vuetifyColor = this.vuetifyColors.find(c => c.name === this.selectedColor || c.hex === this.selectedColor)
      return vuetifyColor ? vuetifyColor.name_sv : this.selectedColor
    },
    colorPickerColor: {
      get: function () {
        // Ensure the color is in hex format for the color picker
        if (this.selectedColor && this.selectedColor.startsWith('#')) {
          return this.selectedColor + 'FF' // Append full opacity
        } else {
          return this.vuetifyColors.find(c => c.name === this.selectedColor)?.hex + 'FF' || '#000000FF'
        }
      },
      set: function (val) {
        const vuetifyColor = this.vuetifyColors.find(c => (c.hex + 'FF') === val)
        if (vuetifyColor) {
          this.selectedColor = vuetifyColor.name
        } else {
          this.selectedColor = val.substring(0, 7) // Extract hex part only
        }
      }
    }
  },
  methods: {},
  watch: {
    colorPickerColor: function (newVal) {
      this.hexTextField = newVal.substring(0, 7)
    },
    hexTextField: function (newVal) {
      // Tillåter formaten #RRGGBB och RRGGBB
      if (/^#([0-9A-Fa-f]{6})$/.test(newVal) || /^([0-9A-Fa-f]{6})$/.test(newVal)) {
        const vuetifyColor = this.vuetifyColors.find(c => c.hex === newVal)
        if (vuetifyColor) {
          this.selectedColor = vuetifyColor.name
        } else {
          this.selectedColor = newVal.toUpperCase()
        }
      }
    }
  }
}
</script>
